var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supplier-modal modal-small", attrs: { tabindex: "0" } },
    [
      _c("h3", [_vm._v("CAP Commitment Form")]),
      _vm._v(" "),
      _c("h4", [_vm._v(_vm._s(_vm.result.SupplierName))]),
      _vm._v(" "),
      _c("div", { staticClass: "terms-agree" }, [
        _c("p", [
          _vm._v(
            "By clicking below, I agree to drop this CAP Supplier and forfeit any future CAP Rebates provided."
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.accept()
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.accept()
              }
            }
          },
          [_vm._v("I Agree")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.cancel()
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.cancel()
              }
            }
          },
          [_vm._v("Cancel")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-945ded56", { render: render, staticRenderFns: staticRenderFns })
  }
}